export default "__VITE_ASSET__94de6658__"